import { Spotlight_Controller } from '@app/controllers/spotlight-controller'
import {
    Project_Assembly_Date_Task,
    Project_Estimate_Task,
    Project_Planning_Task,
    Project_Task
} from '@app/controllers/project-task'

/**
 * Steuert die offene Aufgaben eines Projektes.
 * Singleton – Initialisierung nur in project.ts.
 */
export class Tasks_Controller {
    private static instance: Tasks_Controller | null = null

    private readonly project_status: string | null = null

    private tasks: Map<string, Project_Task>

    /** @private Verhindert externe Instanziierung. */
    private constructor() {
        this.project_status = action_tab

        this.bind_events()

        this.tasks = new Map<string, Project_Task>()

        this.init_tasks()

        if ( gt_user_settings.auto_open_project_tasks === '1' ) {
            this.check_tasks()
        }
    }

    private init_tasks() {
        switch ( this.project_status ) {
            case 'planning':
                this.init_planning_tasks()
                break
            default:
                console.log( '[Tasks Controller] beendet - kein Bereich mit aktuellen Aufgaben' )
        }
    }

    private check_tasks() {
        switch ( this.project_status ) {
            case 'planning':
                this.check_planning_tasks()
                break
            default:
        }
    }

    /**
     * Erstellt die Singleton-Instanz und prüft offene Aufgaben.
     *
     * Benötigt den Boss-Mode des Superchefs.
     *
     * @throws {Error} Wenn bereits initialisiert
     */
    public static init(): Tasks_Controller {
        if ( Tasks_Controller.instance ) {
            throw new Error( '[Tasks Controller] wurde bereits initialisiert.' )
        }


        Tasks_Controller.instance = new Tasks_Controller()
        return Tasks_Controller.instance
    }

    /**
     * Gibt die bestehende Instanz zurück.
     *
     * @throws {Error} Wenn noch nicht initialisiert
     */
    public static getInstance(): Tasks_Controller {
        if ( ! Tasks_Controller.instance ) {
            throw new Error( 'Tasks_Controller wurde noch nicht initialisiert.' )
        }
        return Tasks_Controller.instance
    }

    private init_planning_tasks(): void {
        const estimates = project.get_meta_value( 'project-planning-estimates' )
        console.log( '[Tasks Controller] estimates', estimates )

        this.tasks.set( 'cutting-estimate', new Project_Estimate_Task( 'cutting-estimate' ) )
        this.tasks.set( 'cnc-estimate', new Project_Estimate_Task( 'cnc-estimate' ) )
        this.tasks.set( 'fitting-estimate', new Project_Estimate_Task( 'fitting-estimate' ) )
        this.tasks.set( 'finishing-estimate', new Project_Estimate_Task( 'finishing-estimate' ) )
        this.tasks.set( 'assembly-estimate', new Project_Estimate_Task( 'assembly-estimate' ) )

        this.tasks.set( 'offer-cutting-estimate', new Project_Estimate_Task( 'offer-cutting-estimate' ) )
        this.tasks.set( 'offer-cnc-estimate', new Project_Estimate_Task( 'offer-cnc-estimate' ) )
        this.tasks.set( 'offer-fitting-estimate', new Project_Estimate_Task( 'offer-fitting-estimate' ) )
        this.tasks.set( 'offer-finishing-estimate', new Project_Estimate_Task( 'offer-finishing-estimate' ) )
        this.tasks.set( 'offer-assembly-estimate', new Project_Estimate_Task( 'offer-assembly-estimate' ) )

        this.tasks.set( 'measurement-complete', new Project_Planning_Task( 'measurement-complete' ) )
        this.tasks.set( 'customer-approval-complete', new Project_Planning_Task( 'customer-approval-complete' ) )
        this.tasks.set( 'construction-plans-complete', new Project_Planning_Task( 'construction-plans-complete' ) )
        this.tasks.set( 'production-approval-complete', new Project_Planning_Task( 'production-approval-complete' ) )
        this.tasks.set( 'staff-meeting-complete', new Project_Planning_Task( 'staff-meeting-complete' ) )

        this.tasks.set( 'assembly-date', new Project_Assembly_Date_Task( 'assembly-date' ) )
    }

    private check_planning_tasks(): void {
        console.log( '[Tasks Controller] show modal' )

        this.tasks.get( 'cutting-estimate' )?.check()
        this.tasks.get( 'cnc-estimate' )?.check()
        this.tasks.get( 'fitting-estimate' )?.check()
        this.tasks.get( 'finishing-estimate' )?.check()
        this.tasks.get( 'assembly-estimate' )?.check()

        this.tasks.get( 'offer-cutting-estimate' )?.check()
        this.tasks.get( 'offer-cnc-estimate' )?.check()
        this.tasks.get( 'offer-fitting-estimate' )?.check()
        this.tasks.get( 'offer-finishing-estimate' )?.check()
        this.tasks.get( 'offer-assembly-estimate' )?.check()

        this.tasks.get( 'measurement-complete' )?.check()
        this.tasks.get( 'customer-approval-complete' )?.check()
        this.tasks.get( 'construction-plans-complete' )?.check()
        this.tasks.get( 'production-approval-complete' )?.check()
        this.tasks.get( 'staff-meeting-complete' )?.check()

        this.tasks.get( 'assembly-date' )?.check()

        this.show_modal()
    }

    private show_modal(): void {
        const modal = app.get_modal( 'project-tasks' )
        modal.modal( 'show' )
    }

    /**
     * Bindet Event-Listener für den Spotlight-Modus.
     */
    private bind_events(): void {
        jQuery( '[data-action="close-modal"]' ).on( 'click', () => app.close_modals() )
        jQuery( '[data-action="check-project-tasks"]' ).on( 'click', () => this.check_tasks() )
    }

    public init_spotlight( spotlight: string ) {
        console.log( '[Tasks Controller] initiate spotlight:', spotlight )

        app.close_modals()

        switch ( spotlight ) {
            case 'offer-cutting-estimate':
                project.tabs.tab( 'change tab', 'planning-offer-estimates' )
                this.show_spotlight( '#form-edit-project-offer-estimates .estimate.status-cutting' )
                break
            case 'offer-cnc-estimate':
                project.tabs.tab( 'change tab', 'planning-offer-estimates' )
                this.show_spotlight( '#form-edit-project-offer-estimates .estimate.status-cnc' )
                break
            case 'offer-finishing-estimate':
                project.tabs.tab( 'change tab', 'planning-offer-estimates' )
                this.show_spotlight( '#form-edit-project-offer-estimates .estimate.status-finishing' )
                break
            case 'offer-fitting-estimate':
                project.tabs.tab( 'change tab', 'planning-offer-estimates' )
                this.show_spotlight( '#form-edit-project-offer-estimates .estimate.status-fitting' )
                break
            case 'offer-assembly-estimate':
                project.tabs.tab( 'change tab', 'planning-offer-estimates' )
                this.show_spotlight( '#form-edit-project-offer-estimates .estimate.status-assembly' )
                break
            case 'cutting-estimate':
                project.tabs.tab( 'change tab', 'planning-estimates' )
                this.show_spotlight( '#form-edit-project-estimates .estimate.status-cutting' )
                break
            case 'cnc-estimate':
                project.tabs.tab( 'change tab', 'planning-estimates' )
                this.show_spotlight( '#form-edit-project-estimates .estimate.status-cnc' )
                break
            case 'fitting-estimate':
                project.tabs.tab( 'change tab', 'planning-estimates' )
                this.show_spotlight( '#form-edit-project-estimates .estimate.status-fitting' )
                break
            case 'finishing-estimate':
                project.tabs.tab( 'change tab', 'planning-estimates' )
                this.show_spotlight( '#form-edit-project-estimates .estimate.status-finishing' )
                break
            case 'assembly-estimate':
                project.tabs.tab( 'change tab', 'planning-estimates' )
                this.show_spotlight( '#form-edit-project-estimates .estimate.status-assembly' )
                break
            case 'measurement-complete':
                this.show_spotlight( 'li[data-task="measurement-complete"]' )
                break
            case 'customer-approval-complete':
                this.show_spotlight( 'li[data-task="customer-approval-complete"]' )
                break
            case 'construction-plans-complete':
                this.show_spotlight( 'li[data-task="construction-plans-complete"]' )
                break
            case 'production-approval-complete':
                this.show_spotlight( 'li[data-task="production-approval-complete"]' )
                break
            case 'staff-meeting-complete':
                this.show_spotlight( 'li[data-task="staff-meeting-complete"]' )
                break
            case 'assembly-date':

                // @ts-expect-error global in meta.js
                collapse_meta_list()
                this.show_spotlight( '.meta-item[data-action="update-project-assembly-date"]' )
                break
        }
    }

    public show_spotlight( selector: string ) {
        const spotlight_controller = Spotlight_Controller.getInstance()
        const el: HTMLElement|null = document.querySelector( selector )

        if ( el ) {
            spotlight_controller.show( el )
        }
    }
 }
